<template>
    <svg viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5999 4H1.3999M3.5 9.8028L7 6.40002M7 6.40002L10.5 9.8028M7 6.40002L7 14.8" stroke="#060606" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M22.7783 14H21.1309V5.40039H18.2051V4.00586H25.6973V5.40039H22.7783V14Z" fill="#060606"/>
    </svg>
</template>